import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "sheet relative overflow-hidden bg-white p-8 border border-gray-200 rounded-xl",
  id: "request-voucher"
}
const _hoisted_2 = { class: "flex justify-between items-start border-b-2 border-theme-active pb-6 mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-theme-active uppercase tracking-tight" }
const _hoisted_4 = { class: "text-gray-500 font-medium" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-12" }
const _hoisted_6 = { class: "space-y-8" }
const _hoisted_7 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_8 = { class: "text-lg font-bold text-gray-800" }
const _hoisted_9 = { class: "space-y-4 text-sm" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_11 = { class: "text-gray-800 font-bold text-base" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_13 = { class: "text-gray-800 font-bold" }
const _hoisted_14 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_15 = { class: "text-gray-800 font-bold" }
const _hoisted_16 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_17 = { class: "text-gray-800 font-bold" }
const _hoisted_18 = {
  key: 4,
  class: "flex flex-col"
}
const _hoisted_19 = { class: "text-gray-800 font-bold" }
const _hoisted_20 = {
  key: 5,
  class: "mt-4 space-y-4"
}
const _hoisted_21 = { class: "text-xs font-bold text-theme-active uppercase mb-2" }
const _hoisted_22 = { class: "grid grid-cols-1 gap-1" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "text-gray-800 font-bold block" }
const _hoisted_28 = { class: "space-y-8" }
const _hoisted_29 = { class: "space-y-4 text-sm" }
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = { class: "text-gray-800 font-bold text-base" }
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_33 = { class: "text-gray-800 font-bold" }
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { class: "text-gray-800 font-bold underline" }
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "text-gray-800 font-bold" }
const _hoisted_38 = { class: "flex gap-4" }
const _hoisted_39 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_40 = { class: "text-gray-800 font-bold font-mono text-base" }
const _hoisted_41 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_42 = { class: "text-gray-800 font-bold font-mono text-base" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "text-sm text-gray-700 italic bg-gray-50 p-4 rounded-lg border-l-4 border-gray-200" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestVoucher',
  props: {
    lead: {},
    leadId: {}
  },
  setup(__props: any) {

const props = __props

const isPlanTrip = computed(() => props.lead.service === 'plan_trip')

const title = computed(() => {
  switch (props.lead.service) {
    case 'car_rental': return 'Car Rental Request'
    case 'meet_greet': return 'Meet & Greet Request'
    case 'buses_coaches': return 'Bus & Coach Request'
    case 'plan_trip': return 'Custom Trip Request'
    default: return 'Booking Request'
  }
})

const serviceHeader = computed(() => {
  return isPlanTrip.value ? 'Requested Itinerary' : 'Service Details'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(title.value), 1),
        _createElementVNode("p", _hoisted_4, "Request ID: #" + _toDisplayString(_ctx.leadId), 1)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-right" }, [
        _createElementVNode("div", { class: "text-xl font-bold text-gray-800" }, "VEHITRA WORLD"),
        _createElementVNode("div", { class: "text-xs text-gray-500 uppercase tracking-widest" }, "International Ground Transportation")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_7, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-1 h-6 bg-theme-active" }, null, -1)),
            _createElementVNode("h2", _hoisted_8, _toDisplayString(serviceHeader.value), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.lead.vehicleType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Vehicle Type", -1)),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.lead.vehicleType), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.lead.pickUp?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Pick-up Location", -1)),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.lead.pickUp.name), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.lead.pickUp?.date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Pick-up Date/Time", -1)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.lead.pickUp.date) + " " + _toDisplayString(_ctx.lead.pickUp.time), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.lead.dropOff?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Drop-off Location", -1)),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.lead.dropOff.name), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.lead.dropOff?.date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Drop-off Date/Time", -1)),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.lead.dropOff.date) + " " + _toDisplayString(_ctx.lead.dropOff.time), 1)
                ]))
              : _createCommentVNode("", true),
            (isPlanTrip.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lead.trip?.items, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "p-3 bg-gray-50 rounded-lg border border-gray-100"
                    }, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.type) + " Service", 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", null, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-gray-400 font-medium" }, "From:", -1)),
                          _createTextVNode(" " + _toDisplayString(item.pickUp.name), 1)
                        ]),
                        (item.dropOff?.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-gray-400 font-medium" }, "To:", -1)),
                              _createTextVNode(" " + _toDisplayString(item.dropOff.name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-gray-400 font-medium" }, "When:", -1)),
                          _createTextVNode(" " + _toDisplayString(item.pickUp.date) + " " + _toDisplayString(item.pickUp.time), 1)
                        ]),
                        (item.days)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-gray-400 font-medium" }, "Duration:", -1)),
                              _createTextVNode(" " + _toDisplayString(item.days) + " Day(s)", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.lead.pickUp?.flightNumber)
          ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
                _createElementVNode("div", { class: "w-1 h-6 bg-theme-active" }),
                _createElementVNode("h2", { class: "text-lg font-bold text-gray-800" }, "Travel Details")
              ], -1)),
              _createElementVNode("div", _hoisted_26, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Flight Number", -1)),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.lead.pickUp.flightNumber), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("section", null, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
            _createElementVNode("div", { class: "w-1 h-6 bg-theme-active" }),
            _createElementVNode("h2", { class: "text-lg font-bold text-gray-800" }, "Guest Information")
          ], -1)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Name", -1)),
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.lead.guest.name), 1)
            ]),
            (_ctx.lead.guest.age)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Age", -1)),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.lead.guest.age), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_34, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Email", -1)),
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.lead.guest.email), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Phone", -1)),
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.lead.guest.contactNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              (_ctx.lead.people)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Pax", -1)),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.lead.people), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.lead.luggage !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-gray-500 font-semibold uppercase text-xs" }, "Luggage", -1)),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.lead.luggage), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.lead.guest.message)
          ? (_openBlock(), _createElementBlock("section", _hoisted_43, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
                _createElementVNode("div", { class: "w-1 h-6 bg-theme-active" }),
                _createElementVNode("h2", { class: "text-lg font-bold text-gray-800" }, "Special Instructions")
              ], -1)),
              _createElementVNode("p", _hoisted_44, " \"" + _toDisplayString(_ctx.lead.guest.message) + "\" ", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mt-16 pt-8 border-t border-gray-100 text-center" }, [
      _createElementVNode("p", { class: "text-xs text-gray-400 uppercase tracking-widest font-bold mb-2" }, "Vehitra World — On-Request Reservation"),
      _createElementVNode("p", { class: "text-[10px] text-gray-300" }, "This is a formal request for service. Our team will verify availability and contact you with a final confirmation and payment details.")
    ], -1))
  ]))
}
}

})